import React from 'react';
const images = require("../../../../../../images.json");
const loading = images.loading

export default class Uploading extends React.Component {
    state = {
        animating: false,
    }

    closeModal = () => {
        this.setState({animating: true})
        setTimeout(() => {
            this.setState({animating: false});
            this.props.close();
        }, 250)
    }

    onSubmit = () => {
        this.props.onSubmit();
        this.closeModal();
    }

    render() {
        let clases = ["modal"]

        if(this.state.animating)
            clases.push("animating")
        if(this.props.isActive)
            clases.push("is-active")

        return (
            <div className="Confirm">
                <div className={clases.join(" ")}>
                    <div className="modal-background"></div>
                    <div className="modal-card">
                        <header className="modal-card-head">
                            <p className="modal-card-title">Agregando base de datos</p>
                        </header>
                        <section style={{
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center"
                            }}
                            className="modal-card-body"
                        >
                            <p>Esto puede tardar unos minutos</p>
                            {this.props.uploading &&
                            <p>Leyendo archivo {this.props.progress}%</p>}
                            <img width={150} height={150} src={loading} alt="Loading" />
                        </section>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/add-json/components/uploading/index.js